import { Logo } from "@/components/Logo";

const LogoComponent: React.FC = (props) => {
  return <Logo {...props} className="h-full w-full py-2" />;
};

export default LogoComponent;
